const ventures = [
	{
		path: '/ventures/dashboard',
		name: 'ventures-dashboard',
		component: () => import('@/views/ventures/dashboard/Index.vue'),
		meta: { layout: 'content', module: 'MGV,dashboard' },
	},
	// Reference CRUDs
	{
		path: '/ventures/categories',
		name: 'ventures-categories-list',
		component: () => import('@/views/ventures/categories/list.vue'),
		meta: { layout: 'content', module: 'MGV,categories' },
	},
	{
		path: '/ventures/regions',
		name: 'ventures-regions-list',
		component: () => import('@/views/ventures/regions/list.vue'),
		meta: { layout: 'content', module: 'MGV,regions' },
	},
	{
		path: '/ventures/investor-types',
		name: 'ventures-investor-types-list',
		component: () => import('@/views/ventures/investor-types/list.vue'),
		meta: { layout: 'content', module: 'MGV,investor-types' },
	},
	{
		path: '/ventures/pitch-media-types',
		name: 'ventures-pitch-media-types-list',
		component: () => import('@/views/ventures/pitch-media-types/list.vue'),
		meta: { layout: 'content', module: 'MGV,pitch-media-types' },
	},
	{
		path: '/ventures/score-axes',
		name: 'ventures-score-axes-list',
		component: () => import('@/views/ventures/score-axes/list.vue'),
		meta: { layout: 'content', module: 'MGV,score-axes' },
	},
	{
		path: '/ventures/stages',
		name: 'ventures-stages-list',
		component: () => import('@/views/ventures/stages/list.vue'),
		meta: { layout: 'content', module: 'MGV,stages' },
	},
	// Full CRUDs
	{
		path: '/ventures/projects',
		name: 'ventures-projects-list',
		component: () => import('@/views/ventures/projects/list.vue'),
		meta: { layout: 'content', module: 'MGV,projects' },
	},
	{
		path: '/ventures/investors',
		name: 'ventures-investors-list',
		component: () => import('@/views/ventures/investors/list.vue'),
		meta: { layout: 'content', module: 'MGV,investors' },
	},
	{
		path: '/ventures/investor-prospects',
		name: 'ventures-investor-prospects-list',
		component: () => import('@/views/ventures/investor-prospects/list.vue'),
		meta: { layout: 'content', module: 'MGV,investor-prospects' },
	},
	{
		path: '/ventures/studio-prospects',
		name: 'ventures-studio-prospects-list',
		component: () => import('@/views/ventures/studio-prospects/list.vue'),
		meta: { layout: 'content', module: 'MGV,studio-prospects' },
	},
	{
		path: '/ventures/publishers',
		name: 'ventures-publishers-list',
		component: () => import('@/views/ventures/publishers/list.vue'),
		meta: { layout: 'content', module: 'MGV,publishers' },
	},
	{
		path: '/ventures/investments',
		name: 'ventures-investments-list',
		component: () => import('@/views/ventures/investments/list.vue'),
		meta: { layout: 'content', module: 'MGV,investments' },
	},
	// Operational
	{
		path: '/ventures/waitlist',
		name: 'ventures-waitlist-list',
		component: () => import('@/views/ventures/waitlist/list.vue'),
		meta: { layout: 'content', module: 'MGV,waitlist' },
	},
	{
		path: '/ventures/pitches',
		name: 'ventures-pitches-list',
		component: () => import('@/views/ventures/pitches/list.vue'),
		meta: { layout: 'content', module: 'MGV,pitches' },
	},
	{
		path: '/ventures/connections',
		name: 'ventures-connections-list',
		component: () => import('@/views/ventures/connections/list.vue'),
		meta: { layout: 'content', module: 'MGV,connections' },
	},
	{
		path: '/ventures/score-engine',
		name: 'ventures-score-engine-list',
		component: () => import('@/views/ventures/score-engine/list.vue'),
		meta: { layout: 'content', module: 'MGV,score-engine' },
	},
]

export default ventures
